module.exports = __webpack_public_path__ + "static/media/axis_of_polarization_00122.d8fda598.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/axis/en/axis_of_polarization_00122.png
// module id = 852
// module chunks = 0